import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const OminousIcon = React.memo(function OminousIcon(props: TOminousIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Ominous" {...props}>
            <g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 22 22)">
                <path
                    clipRule="evenodd"
                    fillRule="evenodd"
                    d="M11 17.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-10.1a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm-.86 6.491c0 .06.078.109.172.109h1.375c.095 0 .172-.05.172-.109v-5.032c0-.06-.077-.109-.172-.109h-1.375c-.094 0-.172.05-.172.11v5.031Z"
                ></path>
            </g>
        </IconBase>
    );
});

export default OminousIcon;

// #region Types

export type TOminousIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <OminousIcon /> : { ...IconBaseExample, render: OminousIcon };

// #endregion
